import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SsmService } from 'src/app/shared/services';
import { map } from 'rxjs/operators';
import { get as _get } from 'lodash';
import { DxButtonComponent } from 'devextreme-angular/ui/button';
import { DxLoadPanelComponent } from 'devextreme-angular/ui/load-panel';
import {
    LAZADA_STORES,
    LazadaOAuthParams,
    lazadaOAuthParamsFor,
} from 'src/app/shared/config/store-config';

interface LazadaStore extends LazadaOAuthParams {
    name: string;
}

@Component({
    selector: 'app-api-auth-settings',
    templateUrl: './api-auth-settings.component.html',
    styleUrls: ['./api-auth-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxButtonComponent, DxLoadPanelComponent],
})
export class ApiAuthSettingsComponent {
    private ssmService = inject(SsmService);

    isLoading = false;

    // Every Lazada store in the registry, so a store added there shows up here
    // without a second edit. The paths are derived, not asserted: whether
    // /gen4group/lazada/callback_url and friends actually exist in SSM has not
    // been confirmed — an authorization attempt that silently does nothing is
    // the symptom of a missing one.
    stores: LazadaStore[] = LAZADA_STORES.map((store) => ({
        name: store.title,
        ...lazadaOAuthParamsFor(store.storeId),
    }));

    navigateLazadaAuth(store: LazadaStore): void {
        const redirectUriKey = store.callbackUrlKey;
        const clientIdKey = store.appKeyKey;
        this.isLoading = true;
        this.ssmService
            .getParameters([redirectUriKey, clientIdKey])
            .pipe(
                map((response) => {
                    const redirectUri = _get(response, redirectUriKey);
                    const clientId = _get(response, clientIdKey);
                    if (redirectUri && clientId) {
                        window.open(
                            `https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=${redirectUri}&client_id=${clientId}&state=${store.authCodeKey}`,
                            '_blank',
                        );
                    }
                    return [];
                }),
            )
            .subscribe(() => {
                this.isLoading = false;
            });
    }
}
